import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './Toggle.module.css';

const Toggle = props => {
  const { selected, onClick } = props;
  return (
    <div className={styles.toggleContainer} onClick={onClick}>
      <div className={classNames({ [styles.dialogButton]: true, [styles.disabled]: selected })} />
    </div>
  );
};

export default Toggle;

Toggle.propTypes = {
  selected: PropTypes.bool,
  onClick: PropTypes.func,
};

Toggle.defaultProps = {
  selected: false,
  onClick: () => { },
};
